import { Controller, type Control, type FieldPath, type FieldValues } from 'react-hook-form';

import { FieldCurrencyInput } from './field-currency-input';

interface FormFieldCurrencyInputProps<T extends FieldValues>
  extends Omit<React.ComponentProps<typeof FieldCurrencyInput>, 'value' | 'onChange' | 'onBlur' | 'errors'> {
  control: Control<T>;
  name: FieldPath<T>;
}

export function FormFieldCurrencyInput<T extends FieldValues>({ control, name, ...rest }: FormFieldCurrencyInputProps<T>) {
  return (
    <Controller
      control={control}
      name={name}
      render={({ field, fieldState }) => (
        <FieldCurrencyInput
          {...rest}
          value={field.value ?? ''}
          onChange={field.onChange}
          onBlur={field.onBlur}
          ref={field.ref}
          errors={fieldState.error ? [fieldState.error] : undefined}
        />
      )}
    />
  );
}
